import { CheckCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import * as APITypes from "~/API";
import { useTranslation } from "react-i18next";
import { COLORS } from "~/utils";

export const TenantAuthTag = ({
  authType,
  authID,
}: {
  authType: APITypes.TenantType;
  authID: string;
}) => {
  const { t } = useTranslation();
  let color = COLORS.grey;
  let authSymbol = <QuestionCircleOutlined />;
  let authText = t(authType as any);

  if (authType === APITypes.TenantType.AuthenticatedTenant || authID !== "") {
    authSymbol = <CheckCircleOutlined />;
    color = COLORS.vibrant_green;
    authText = t("AuthenticatedTenant");
  }

  return (
    <Tag color={color}>
      {authSymbol} {authText}
    </Tag>
  );
};
